module.exports = " <div> <sidebar></sidebar> <router-view></router-view> <gh-corner v-transfer-dom repo-user=wovue repo-name=dialog color=#EAE8EB background=#35495E></gh-corner> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src-docs/app/components/Root.vue
 ** module id = 127
 ** module chunks = 1
 **/